export default __webpack_public_path__ + "static/media/bScoreShapes2Background.13124f10.svg";